import Yard from 'src/models/yard';

export const Yards: Yard[] = [
  {
    id: 1,
    name: 'Azimut',
    description: null,
    users: [],
  },
  {
    id: 2,
    name: 'Rina',
    description: null,
    users: [],
  },
  {
    id: 3,
    name: 'San Lorenzo',
    description: null,
    users: [],
  },
  {
    id: 4,
    name: 'Benetti',
    description: null,
    users: [],
  },
  {
    id: 5,
    name: 'ABS',
    description: null,
    users: [],
  },
  {
    id: 6,
    name: 'TUBINAVI',
    description: null,
    users: [],
  },
  {
    id: 7,
    name: 'AMBRA NAVAL',
    description: null,
    users: [],
  },
  {
    id: 8,
    name: 'Lusben',
    description: null,
    users: [],
  },
  {
    id: 9,
    name: 'CUPINI',
    description: null,
    users: [],
  },
  {
    id: 10,
    name: 'BlueGame',
    description: null,
    users: [],
  },
  {
    id: 11,
    name: 'CARBONOVUS',
    description: null,
    users: [],
  },
];
